module.exports = __webpack_public_path__ + "static/media/Wide-modal.aca50908.webp";